import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {createMetSelectWrapper, MetSelectDropdown, MetSelectInput} from 'topmeteo/general/components/MetSelectWrapper';

import {changeLocation} from '../../actionCreators';
import {getLocation, getPOIs} from '../../selectors';

import LocationList from './List';
import LocationManager from './LocationManager';

const OptGroupLabel = gettext('Location');

const LocationSelect = ({locations, locationID, name, onChange, ...props}) => (
    <div className="met-select-wrapper">
        <select className="met-select" value={locationID} onChange={onChange}>
            <optgroup label={OptGroupLabel}>
                {locations.filter(({region}) => region).map(({id, name}) => (
                    <option value={id} key={id}>{name}</option>
                ))}
            </optgroup>
        </select>
        <div className="met-location-manager mobile-only">
            <LocationManager>
                <span className="control icon-cog" />
            </LocationManager>
        </div>
        <MetSelectDropdown {...props}>
            <MetSelectInput {...props} value={name} />
            <LocationList {...props} selected={locationID} locations={locations} />
        </MetSelectDropdown>
    </div>
);

const LocationSelectWrapper = createMetSelectWrapper(LocationSelect);

const mapStateToProps = state => {
    const {isAnonymous} = state;
    const locations = getPOIs(state);
    const {id, name} = getLocation(state);

    return {
        name,
        locations,
        isAnonymous,
        locationID: id,
    };
};

const mapDispatchToProps = dispatch => ({
    onChange: ({target: {value}}) => dispatch(changeLocation(value.indexOf('@') === 0 ? value : +value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationSelectWrapper);
